import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ContactDto } from './types/ContactDto';
import { catchError, map } from 'rxjs/operators';
import { PersonDataDto } from './types/PersonDataDto';
import { OeAppService } from './oe-app.service';
import { ProfileImageUploadDTO } from './types/ProfileImageUploadDTO';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  constructor(private http: HttpClient, private oeAppService: OeAppService) {}

  updatePersonData(data): Observable<any> {
    return this.http.post('/stu/info', data).pipe(catchError(() => of(null)));
  }

  getContactData(): Observable<ContactDto> {
    return this.http.get<ContactDto>('/stu/contact');
  }

  get address$(){
    return this.getContactData().pipe(map(({ address }) => address))
  }

  saveContactData(data: ContactDto): Observable<any> {
    return this.http.post('/stu/contact', data);
  }

  hasUploadedPhoto(): Observable<string> {
    return this.http.get<string>('/profile/imageuploaded', {
      responseType: 'text' as 'json',
    });
  }

  uploadImage(data: ProfileImageUploadDTO): Observable<any> {
    return this.http.post<any>(`${this.oeAppService.oeProfileServiceHost}/v1/images/upload`, data);
  }

  updateProfile(personId: number, data: Partial<PersonDataDto>): Observable<PersonDataDto> {
    return this.http.put<PersonDataDto>(
      `stu/persons/specific`,
      {
        ...data,
        personId
      }
    );
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/profile.service.ts